// import API_BASE_URL from "../../config";

// import React, { useState, useContext, useEffect } from "react";
// import { useHistory } from "react-router-dom";
// import { UserContext } from "../../contexts/UserContext";
// import "./AuthPage.css"; // Ensure you create this CSS file for styling

// const SignIn = () => {
//   const history = useHistory();
//   const { dispatch } = useContext(UserContext);
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [error, setError] = useState("");

//   // useEffect to sign out user when they reach the SignIn page
//   useEffect(() => {
//     localStorage.clear();
//     dispatch({ type: "CLEAR" });
//   }, [dispatch]);

//   const handleSignIn = async (e) => {
//     e.preventDefault();
//     setError("");

//     if (!email || !password) {
//       setError("Both fields are required.");
//       return;
//     }

//     try {
//       const response = await fetch(`${API_BASE_URL}/signin`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({
//           email: email.toLowerCase(),
//           password,
//         }),
//       });

//       if (response.ok) {
//         const data = await response.json();
//         localStorage.setItem("jwt", data.token);
//         localStorage.setItem("user", JSON.stringify(data.user));
//         dispatch({ type: "USER", payload: data.user });

//         if (data.user.role === "admin") {
//           history.push("/createpost");
//         } else {
//           history.push("/");
//         }
//       } else {
//         const errorData = await response.json();
//         setError(errorData.error || "Invalid credentials.");
//       }
//     } catch (error) {
//       setError("An error occurred. Please try again later.");
//       console.error("Error:", error);
//     }
//   };

//   return (
//     <div className="auth-container">
//       <form className="auth-form" onSubmit={handleSignIn}>
//         <h1>Sign In</h1>
//         <p>(Please Sign-in or Sign-up and Vote)</p>
//         <input
//           type="email"
//           placeholder="Email"
//           value={email}
//           onChange={(e) => setEmail(e.target.value)}
//           required
//         />
//         <input
//           type="password"
//           placeholder="Password"
//           value={password}
//           onChange={(e) => setPassword(e.target.value)}
//           required
//         />
//         <button type="submit" className="auth-button">
//           Sign In
//         </button>
//         {error && <p className="error-message">{error}</p>}
//         <p>
//           Don't have an account? <a href="/signup">Sign Up</a>
//         </p>
//       </form>
//     </div>
//   );
// };

// export default SignIn;
import API_BASE_URL from "../../config";

import React, { useState, useContext, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { UserContext } from "../../contexts/UserContext";
import "./AuthPage.css"; // Ensure you create this CSS file for styling

const SignIn = () => {
  const history = useHistory();
  const { dispatch } = useContext(UserContext);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  // useEffect to sign out user when they reach the SignIn page
  useEffect(() => {
    localStorage.clear();
    dispatch({ type: "CLEAR" });
  }, [dispatch]);

  const handleSignIn = async (e) => {
    e.preventDefault();
    setError("");

    if (!email || !password) {
      setError("Both fields are required.");
      return;
    }

    try {
      const response = await fetch(`${API_BASE_URL}/signin`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: email.toLowerCase(),
          password,
        }),
      });

      if (response.ok) {
        const data = await response.json();
        localStorage.setItem("jwt", data.token);
        localStorage.setItem("user", JSON.stringify(data.user));
        dispatch({ type: "USER", payload: data.user });

        if (data.user.role === "admin") {
          history.push("/createpost");
        } else {
          history.push("/");
        }
      } else {
        const errorData = await response.json();
        setError(errorData.error || "Invalid credentials.");
      }
    } catch (error) {
      setError("An error occurred. Please try again later.");
      console.error("Error:", error);
    }
  };

  return (
    <div className="auth-container">
      <form className="auth-form" onSubmit={handleSignIn}>
        <h1>Sign In</h1>
        <p>(Please Sign-in or Sign-up and Vote)</p>
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <button type="submit" className="auth-button">
          Sign In
        </button>
        {error && <p className="error-message">{error}</p>}
        <p>
          Don't have an account? <a href="/signup">Sign Up</a>
        </p>
      </form>
    </div>
  );
};

export default SignIn;
